import { isDateBefore } from "@unit/utility";
import { atom } from "jotai";

import { STAFF_STORE_LIST_MONTHS_OFFSET } from "@/global-state/app-config";
import { authUserAtom, selectStoreAtom } from "@/global-state/jotai-atom";

// One store-specific write (including compensation) survives selector/route remounts.
export const storeSelectionPersistenceAtom = atom({
  operationId: 0,
  userId: undefined as string | undefined,
  pending: false,
  cancelled: false,
  needsRepair: false,
});

export const validSelectedStoreAtom = atom((get) => {
  const selected = get(selectStoreAtom);
  return get(authUserAtom)?.stores.find(
    (store) =>
      store.id === selected?.id && !isDateBefore(store.contractEndDate, undefined, STAFF_STORE_LIST_MONTHS_OFFSET),
  );
});
